import React, { Fragment } from 'react'
import { NavLink } from 'react-router-dom'
const CityAround = () => {
    return (
        <Fragment>

            <section className='home_restimonials city_around_sec'>
                <div className='container'>
                    <h2 className='mb-1'>10+ Years Of Digital Marketing Brilliance</h2>
                    <h3 className='mb-5'>Sparking Success In Thriving Urban Centers!</h3>
                    <ul className='row city_list'>
                        <li>
                            <NavLink to="/us/city/seo-company-philadelphia">Philadelphia</NavLink>
                        </li>
                        <li>
                            <NavLink to="/us/city/seo-company-atlanta">Atlanta</NavLink>
                        </li>
                        <li>
                            <NavLink to="/us/city/seo-company-miami">Miami</NavLink>
                        </li>
                        <li>
                            <NavLink to="/us/city/seo-company-las-vegas">Las Vegas</NavLink>
                        </li>
                        <li>
                            <NavLink to="/us/city/seo-company-los-angeles"> Los Angeles</NavLink>
                        </li>
                        <li>
                            <NavLink to="/us/city/seo-company-seattle"> Seattle</NavLink>
                        </li>
                        <li>
                            <NavLink to="/us/city/seo-company-san-diego"> San-Diego</NavLink>
                        </li>
                        <li>
                            <NavLink to="/us/city/seo-company-new-york-city"> New York City</NavLink>
                        </li>
                        <li>
                            <NavLink to="/us/city/seo-company-portland"> Portland</NavLink>
                        </li>
                        <li>
                            <NavLink to="/us/city/seo-company-san-antonio"> San Antonio</NavLink>
                        </li>
                        
                    </ul>
                   
                </div>
            </section>

        </Fragment>
    )
}

export default CityAround